export type ContentFormat = "video" | "audio" | "text";
export type ContentType = "video" | "article" | "podcast";

export interface EducationContent {
	id: string;
	title: string;
	description: string;
	thumbnail: string;
	contentType: ContentType;
	duration: string;
	availableFormats: ContentFormat[];
	isBookmarked: boolean;
	progress?: number;
	currentTime?: string;
}

export interface TrainingItem {
	id: string;
	title: string;
	contentType: ContentType;
	duration: string;
	isCompleted: boolean;
}

export interface LibraryCategory {
	id: string;
	name: string;
	thumbnail: string;
	sourceCount: number;
}

export interface CommunityGroup {
	id: string;
	name: string;
	iconColor: string;
	discussionCount: number;
}

export const MOCK_RECOMMENDED: EducationContent[] = [
	{
		id: "rec-1",
		title: "Understanding IVF: A Complete Guide",
		description:
			"Learn about the IVF process from start to finish, including what to expect at each stage.",
		thumbnail: "/images/education/placeholder-1.svg",
		contentType: "video",
		duration: "10:00",
		availableFormats: ["video", "audio", "text"],
		isBookmarked: false,
	},
	{
		id: "rec-2",
		title: "Nutrition During Fertility Treatment",
		description:
			"Discover the best dietary practices to support your fertility journey and overall well-being.",
		thumbnail: "/images/education/placeholder-2.svg",
		contentType: "article",
		duration: "8:00",
		availableFormats: ["video", "audio", "text"],
		isBookmarked: true,
	},
	{
		id: "rec-3",
		title: "Managing Stress & Anxiety",
		description:
			"Practical techniques for managing stress and anxiety during your fertility treatment.",
		thumbnail: "/images/education/placeholder-3.svg",
		contentType: "podcast",
		duration: "15:00",
		availableFormats: ["video", "audio", "text"],
		isBookmarked: false,
	},
];

export const MOCK_TRAINING: TrainingItem[] = [
	{
		id: "train-1",
		title: "Medication Self-Injection Tutorial",
		contentType: "video",
		duration: "12:00",
		isCompleted: true,
	},
	{
		id: "train-2",
		title: "Pre-Procedure Preparation",
		contentType: "article",
		duration: "5:00",
		isCompleted: true,
	},
	{
		id: "train-3",
		title: "Understanding Your Lab Results",
		contentType: "video",
		duration: "8:00",
		isCompleted: false,
	},
	{
		id: "train-4",
		title: "Post-Transfer Care Guide",
		contentType: "article",
		duration: "6:00",
		isCompleted: false,
	},
];

export const MOCK_RESUME: EducationContent = {
	id: "resume-1",
	title: "Understanding IVF: A Complete Guide",
	description:
		"Learn about the IVF process from start to finish, including what to expect at each stage.",
	thumbnail: "/images/education/placeholder-1.svg",
	contentType: "video",
	duration: "10:00",
	availableFormats: ["video", "audio", "text"],
	isBookmarked: false,
	progress: 0.342,
	currentTime: "3:24",
};

const LIBRARY_BACKGROUND_IMAGES = [
	"/images/explore-education-1.png",
	"/images/explore-education-2.png",
];

export const MOCK_LIBRARY_CATEGORIES: LibraryCategory[] = [
	{
		id: "lib-1",
		name: "IVF & IUI",
		thumbnail: LIBRARY_BACKGROUND_IMAGES[0 % LIBRARY_BACKGROUND_IMAGES.length],
		sourceCount: 12,
	},
	{
		id: "lib-2",
		name: "Nutrition",
		thumbnail: LIBRARY_BACKGROUND_IMAGES[1 % LIBRARY_BACKGROUND_IMAGES.length],
		sourceCount: 8,
	},
	{
		id: "lib-3",
		name: "Mental Health",
		thumbnail: LIBRARY_BACKGROUND_IMAGES[2 % LIBRARY_BACKGROUND_IMAGES.length],
		sourceCount: 15,
	},
	{
		id: "lib-4",
		name: "Medications",
		thumbnail: LIBRARY_BACKGROUND_IMAGES[3 % LIBRARY_BACKGROUND_IMAGES.length],
		sourceCount: 6,
	},
];

export const MOCK_COMMUNITY_GROUPS: CommunityGroup[] = [
	{
		id: "group-1",
		name: "IVF Support Circle",
		iconColor: "#5E60BF",
		discussionCount: 24,
	},
	{
		id: "group-2",
		name: "Nutrition & Wellness",
		iconColor: "#E45BC2",
		discussionCount: 18,
	},
	{
		id: "group-3",
		name: "Two-Week Wait",
		iconColor: "#FF8C00",
		discussionCount: 31,
	},
];

export function getTrainingProgress(items: TrainingItem[]): {
	completed: number;
	total: number;
} {
	return {
		completed: items.filter((item) => item.isCompleted).length,
		total: items.length,
	};
}
